<script setup lang="ts">
import {
    icons,
    registerIconLibrary,
} from "nve-designsystem/registerIcons/systemLibraryCustomization.js";

import { RouterView } from "vue-router";

// Register the custom icon library used by NVE Design System
registerIconLibrary("system", {
    resolver: (name) => {
        return `data:image/svg+xml,${encodeURIComponent(icons[name])}`;
    },
});
</script>

<template>
    <div class="page">
        <main id="page__main" class="page__main">
            <RouterView />
        </main>
    </div>
</template>

<style scoped>
.page {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
}

.page__main {
    background-color: var(--color-neutrals-background-primary);
    display: flex;
    width: 100%;
    padding: var(--spacing-3x-large);
    flex-direction: column;
    gap: var(--spacing-3x-large);
}

@media (max-width: 768px) {
    .page__main {
        padding: var(--spacing-large);
    }
    .page {
        padding: 0 var(--spacing-small);
    }
}

@media (max-width: 600px) {
    .page {
        padding: var(--spacing-small);
    }
}
</style>
